import React, { useEffect, useState } from "react";
import './MidDisplay.css';
import ProductDisplay from "../ProductDisplay/ProductDisplay";

const MidDisplay = () => {
  const [latestProduct, setLatestProduct] = useState(null);

  useEffect(() => {
    fetch('/api/latestproduct')
      .then((response) => response.json())
      .then((data) => setLatestProduct(data))
      .catch((error) => console.error('Error fetching latest product:', error));
  }, []);

  return (
    // Changed to a <section> for better semantics
    <section className="mid-display">
      <div className="container">
        {/* Added a heading for context */}
        <h2>Featured Drop</h2>
        <div className="mid-display__content">
          {latestProduct ? (
            <ProductDisplay product={latestProduct} />
          ) : (
            <p className="loading-text">Loading...</p> // Added a class for styling
          )}
        </div>
      </div>
    </section>
  );
}

export default MidDisplay;